import { injectable } from 'tsyringe'
import { PositionApiRepository } from '@/app/repositories/api/PositionApiRepository'
import { Position, PositionDnet } from '@/domain/entities/Position'
import {
  PostPositionInterface,
  DeletePositionInterface,
  UpdatePositionInterface,
} from '@/data/payload/contracts/PositionRequest'
@injectable()
export class PositionPresenter {
  private repository: PositionApiRepository

  constructor(repository: PositionApiRepository) {
    this.repository = repository
  }

  public loadPosition(): Promise<Position> {
    return this.repository.getAll()
  }
  public loadPositionDnet(): Promise<PositionDnet> {
    return this.repository.getAllDnet()
  }
  public postPosition(payload: PostPositionInterface): Promise<Position> {
    return this.repository.post(payload)
  }

  public updatePosition(
    payload: UpdatePositionInterface,
    id: number
  ): Promise<Position> {
    return this.repository.update(payload, id)
  }

  public deletePosition(payload: DeletePositionInterface): Promise<Position> {
    return this.repository.delete(payload)
  }
}
